import dayjs, { Dayjs } from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { i18n } from 'helpers/i18next'
import 'dayjs/locale/th'

const initDayjs = () => {
  dayjs.extend(calendar)
  dayjs.extend(isBetween)
  dayjs.extend(customParseFormat)
  dayjs.extend(duration)
  dayjs.extend(localizedFormat)
}

export const createMonths = () =>
  Array.from({ length: 12 }, (_, i) => dayjs().locale(i18n.language).month(i).format('MMMM'))

export const getMonthStartEndDates = (year: number, month: number) => {
  const startDate = dayjs(`${year}-${month + 1}-01`).startOf('month')
  const endDate = startDate.endOf('month')

  return {
    startDate,
    endDate,
  }
}

export const isDateInRange = ({ date, minDate, maxDate }: { date: Dayjs; minDate: Dayjs; maxDate: Dayjs }) =>
  !date.isBefore(minDate, 'day') && !date.isAfter(maxDate, 'day')

export const isDateOutsideRange = ({ date, minDate, maxDate }: { date: Dayjs; minDate: Dayjs; maxDate: Dayjs }) =>
  date.isBefore(minDate, 'day') || date.isAfter(maxDate, 'day')

export default initDayjs
